export default __webpack_public_path__ + "static/media/drag.ebbd0a72.svg";